import { Tracker } from '../tracker/tracker';
import { ClickEvent } from './events';
import { setRefIDToLocalStorage } from './ref-id-storage';
export function trackGenericCourseClick({
  courseId,
  courseTrackingId,
  componentName
}) {
  Tracker.publishEvent(new ClickEvent({
    componentName,
    relatedObjectType: ClickEvent.relatedObjectTypes.course,
    relatedObjectId: courseId,
    trackingId: courseTrackingId
  }));
  setRefIDToLocalStorage(courseId, courseTrackingId);
}
//# sourceMappingURL=common-tracking.js.map